module.exports = __webpack_public_path__ + "static/img/miniQr.2c79fd7f.jpg";